import { withRouter } from 'react-router-dom'
import { Calendar } from './Calendar'

export default withRouter(Calendar)
